import type { FC } from "react";
import { useIcon } from "@SeemplicityDev/shared";
import type { NavIcon } from "./navIcon";

interface NavIconGlyphProps {
  icon: NavIcon;
}

const NavIconGlyph: FC<NavIconGlyphProps> = ({ icon }) => {
  const { getSvg } = useIcon();

  if (icon.kind === "font") {
    return (
      <i
        className={`nav-icon seem-icon ${icon.className}`}
        aria-hidden="true"
      />
    );
  }

  const src = getSvg(icon.name);

  if (!src) {
    return null;
  }

  return <img className="nav-icon" src={src} alt="" />;
};

export default NavIconGlyph;
